export default "__VITE_ASSET__CtGCQ9_O__"